import * as uuid from 'uuid';
import { getPointString, getSizeString } from '../../../../../utils/stringify-utils';
import { GroupNodeCreateProps } from '../models/group-node-create-props';
import { GroupNode } from '../models/group-node.model';
import { calculateMinGroupBounds } from '../utils/group-bounds-utils';

export const createGroupNode = (diagram: go.Diagram, { categoryName }: GroupNodeCreateProps): go.Group | null => {
  if (!diagram.selection.count) {
    return null;
  }

  const key = uuid.v4();
  const { x, y, width, height } = calculateMinGroupBounds(diagram, diagram.selection.iterator);

  diagram.commit(() =>
    diagram.model.addNodeData(
      new GroupNode(key, categoryName, getPointString(x, y), getSizeString(width, height), true),
    ),
  );

  const group = diagram.findNodeForKey(key) as go.Group;
  if (group) {
    groupSelection(diagram, group);
  }

  return group;
};

const groupSelection = (diagram: go.Diagram, group: go.Group) => {
  group.addMembers(diagram.selection, true);
};
